import primaryComponents from "../../../primaryComponents";
import { useIntegratedDeviceForm } from "./useIntegratedDeviceForm";
import useValidation from "./useValidation";

export const IntegratedDeviceForm = ({
  isEditMode = false,
  terminal_type = "INTERSWITCH",
  terminalDetails = null,
  closeModal = () => {},
}) => {
  const { storeList, formDetails, isLoading, setFormDetails, handleTerminal } =
    useIntegratedDeviceForm({
      isEditMode,
      terminal_type,
      terminalDetails,
      closeModal,
    });
  const {
    handleSubmit,
    formState: { errors },
    control,
    trigger,
    register,
  } = useValidation({ ...formDetails });

  return (
    <form
      className="d-flex flex-column"
      style={{ gap: "10px" }}
      onSubmit={handleSubmit(handleTerminal)}
    >
      <primaryComponents.InputFieldV2
        control={control}
        classNames="white"
        label="Terminal ID"
        placeholder="Enter terminal ID"
        name="terminal_id"
        value={formDetails?.terminal_id}
        isRequired
        register={register}
        errorMessage={errors.terminal_id}
        onKeyUp={() =>
          errors.terminal_id !== undefined && trigger("terminal_id")
        }
        onChange={({ target: { value } }) => {
          setFormDetails((prevState) => ({
            ...prevState,
            terminal_id: value,
          }));
        }}
      />

      <primaryComponents.InputFieldV2
        control={control}
        classNames="white"
        label="Serial No"
        placeholder="Enter serial no"
        name="terminal_sn"
        value={formDetails?.terminal_sn}
        isRequired
        register={register}
        errorMessage={errors.terminal_sn}
        onKeyUp={() =>
          errors.terminal_sn !== undefined && trigger("terminal_sn")
        }
        onChange={({ target: { value } }) => {
          setFormDetails((prevState) => ({
            ...prevState,
            terminal_sn: value,
          }));
        }}
      />

      <primaryComponents.InputFieldV2
        control={control}
        classNames="white"
        label="Merchant ID"
        placeholder="Enter merchant ID"
        name="merchant_id"
        value={formDetails?.merchant_id}
        isRequired
        register={register}
        errorMessage={errors.merchant_id}
        onKeyUp={() =>
          errors.merchant_id !== undefined && trigger("merchant_id")
        }
        onChange={({ target: { value } }) => {
          setFormDetails((prevState) => ({
            ...prevState,
            merchant_id: value,
          }));
        }}
      />

      <primaryComponents.SelectFieldV2
        control={control}
        name="store_id"
        label="Store"
        options={storeList}
        idKey="id"
        nameKey="name"
        isRequired
        onChange={(value) => {
          setFormDetails((prevState) => ({
            ...prevState,
            store_id: value,
          }));
        }}
        value={
          storeList?.find(
            (store) => `${store?.id}` === `${formDetails?.store_id}`,
          )?.name || "Select stores"
        }
        classNames="store-select"
        isSearchable={false}
        errorMessage={errors.store_id}
      />

      <div className="d-flex align-items-center">
        <primaryComponents.Checkbox
          name={"isEnabledOnCheckout"}
          id={"isEnabledOnCheckout"}
          isChecked={formDetails?.use_on_checkout}
          onChange={() =>
            setFormDetails((prev) => ({
              ...prev,
              use_on_checkout: !formDetails?.use_on_checkout,
            }))
          }
        />
        <label htmlFor="isEnabledOnCheckout" className="mt-1 cursor-pointer">
          Enable on checkout
        </label>
      </div>

      <primaryComponents.Button
        classNames={"btn btn--primary cover mt-4"}
        isLoading={isLoading}
        isDisabled={isLoading}
        loadingText={isEditMode ? "Updating..." : "Adding..."}
        type="submit"
      >
        {isEditMode ? "Update Terminal" : "Add Terminal"}
      </primaryComponents.Button>
    </form>
  );
};
